import { Box, Button, Typography } from '@mui/material';
import React from 'react';

interface OrderDeniedStatusInfoProps {
    closeOrderCartDrawer: () => void;
}

const OrderDeniedStatusInfo: React.FC<OrderDeniedStatusInfoProps> = ({ closeOrderCartDrawer }) => {
    return (
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={1.5}>
            <Typography fontWeight={600} textAlign={"center"}>Nažalost restoran je odbio tvoju narudžbu.</Typography>

            <Button
                sx={{ mt: 2 }}
                color='secondary'
                variant='outlined'
                onClick={closeOrderCartDrawer}>
                Zatvori
            </Button>
        </Box>
    )
}

export default OrderDeniedStatusInfo;